module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "popup-viewer-mask",
    on: {
      "click": _vm.handleClickOutside
    }
  }, [_c('div', {
    staticClass: "popup-viewer-wrapper"
  }, [_c('div', {
    staticClass: "popup-viewer-alert-container",
    class: {
      'popup-viewer-shake': _vm.isClickingOutside
    }
  }, [_c('div', {
    staticClass: "popup-viewer-alert-header"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "popup-viewer-alert-body"
  }, [_vm._t("default")], 2)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a169606","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/popup-viewer/PopupViewerAlert.vue
// module id = 1586
// module chunks = 17